var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotesboard = function SvgNotesboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 110 120"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 99,
    x: 22.5,
    y: 19.5,
    stroke: "#7B4EF8",
    strokeWidth: 3,
    rx: 8.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#7B4EF8",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M33 37h44M33 53h44M33 69h44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#7B4EF8",
    strokeWidth: 3,
    d: "M71.5 14.143V19.5h-33v-5.357c0-1.184.96-2.143 2.143-2.143h1.532A8.325 8.325 0 0 0 50.5 3.675c0-1.201.974-2.175 2.175-2.175h4.65c1.201 0 2.175.974 2.175 2.175A8.325 8.325 0 0 0 67.825 12h1.532c1.184 0 2.143.96 2.143 2.143Z"
  })));
};
export default SvgNotesboard;